<template>
  <div class="score-caption">
    <div class="header-caption">
      <div v-for="face in faceList" :key="face.text" class="face-div">
        <img width="32" :src="face.face" />
        <h4>{{ face.text }}</h4>
        <div class="bar" :style="{backgroundColor: face.color}"></div>
      </div>
    </div>
    <div class="main-caption">
      <div v-for="detail in details" :key="detail.title" class="detail">
        <h3>{{ detail.title }}</h3>
        <h4 class="mb-0">{{ detail.describe }}</h4>
        <div v-for="item in detail.list" :key="item.text">
          <img width="24" :src="item.face" />
          <h4>{{ item.text }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import faceSmile from '@/assets/img/teacherManagement/face-smile.svg';
import faceNormal from '@/assets/img/teacherManagement/face-normal.svg';
import faceAngry from '@/assets/img/teacherManagement/face-angry.svg';
export default {
  computed: {
    faceList() {
      return [
        {text: this.$t('待加強'), face: faceAngry, color: '#E6894F'},
        {text: this.$t('普通'), face: faceNormal, color: '#F0D04C'},
        {text: this.$t('優秀'), face: faceSmile, color: '#A8D17C'},
      ];
    },
    details() {
      return [
        {
          title: `${this.$t('近一週勤勞度')}${this.$t('：')}`,
          describe: this.$t('計算學員近一週學習歷程分數，分為三個等級'),
          list: [
            {face: faceSmile, text: this.$t('20分以上')},
            {face: faceNormal, text: this.$t('10~19 分')},
            {face: faceAngry, text: this.$t('9 分以下')},
          ],
        },
        {
          title: `${this.$t('近一次的檢定')}${this.$t('：')}`,
          list: [
            {face: faceSmile, text: this.$t('通過')},
            {face: faceAngry, text: this.$t('未通過')},
          ],
        },
        {
          title: `${this.$t('近期對弈紀錄')}${this.$t('：')}`,
          describe: this.$t('取近 10 盤對弈狀況，分為三個等級'),
          list: [
            {face: faceSmile, text: this.$t('獲勝 7 盤以上')},
            {face: faceNormal, text: this.$t('獲勝 4~6 盤')},
            {face: faceAngry, text: this.$t('獲勝 3 盤以下')},
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.header-caption {
  display: flex;
  padding: $spacing-s;
  margin-bottom: $spacing-xs;
  align-items: center;
  align-self: stretch;
  background: $white;
  box-shadow: 0px 2px 7px 0px rgba(199, 199, 199, 0.4);
  .face-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $spacing-xs;
    flex: 1 0 0;
  }
  .bar {
    height: 14px;
    width: 100%;
  }
}
.main-caption {
  display: flex;
  padding: var(--spacing-s, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-l, 32px);
  flex: 1 0 0;
  align-self: stretch;
  background: var(--Background-style-1, #fff);

  /* Dropdown shadow */
  box-shadow: 0px 2px 7px 0px rgba(199, 199, 199, 0.4);
}

.detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: $spacing-xs;
  align-self: stretch;
  h3 {
    border-radius: 6px;
    background: #fff1de;
    display: flex;
    height: 40px;
    justify-content: flex-start;
    padding-left: $spacing-s;
    align-items: center;
    align-self: stretch;
    color: $font-grayscale-1;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  div {
    display: flex;
    align-items: center;
    gap: $spacing-xs;
  }
}
</style>
